<template>
    <modal id="finance-transfer-modal"
           size="large"
           v-model="showModal"
           :title="generateModalTitle('transfer')"
           @submit="submitData" :loading="loading"
           :preloader="preloader">

        <form
            ref="form"
            :data-url='selectedUrl ? selectedUrl : `${TENANT_BASE_URL}app/finance-transfers`'
            @submit.prevent="submitData"
        >
            <div class="row">
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('source_account')"
                        list-value-field="name"
                        v-model="formData.source_account_id"
                        :chooseLabel="$t('source_account')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'source_account_id')"
                        :fetch-url="`${TENANT_BASE_URL}app/finance-accounts?all=1`"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('target_account')"
                        list-value-field="name"
                        v-model="formData.target_account_id"
                        :chooseLabel="$t('target_account')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'target_account_id')"
                        :fetch-url="`${TENANT_BASE_URL}app/finance-accounts?all=1`"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="date"
                        :label="$t('date')"
                        :placeholder="$placeholder('date')"
                        v-model="formData.process_date"
                        :required="true"
                        :error-message="$errorMessage(errors, 'process_date')">
                    </app-form-group>
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="number"
                        :label="$t('amount')"
                        :placeholder="$placeholder('amount')"
                        v-model="formData.amount"
                        :required="true"
                        :error-message="$errorMessage(errors, 'amount')">
                    </app-form-group>
                </div>
                <div class="col-md-12">
                    <app-form-group
                        type="textarea"
                        :label="$t('remark')"
                        :placeholder="$textAreaPlaceHolder('remark')"
                        v-model="formData.remark"
                        :text-area-rows="5"
                        :error-message="$errorMessage(errors, 'remark')">
                    </app-form-group>
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import {TENANT_BASE_URL} from "../../../../common/Config/UrlHelper";
import {formDataAssigner} from "../../../../common/Helper/Support/FormHelper";
import {formatDateForServer, today} from "../../../../common/Helper/Support/DateTimeHelper";

export default {
    name: "FinanceTransferCreate",
    props: {
        defaultSourceAccountId: {
            type: [String, Number],
            default: ''
        }
    },
    mixins: [FormHelperMixins, ModalMixin],
    data() {
        return {
            TENANT_BASE_URL,
            formData: {
                id: null,
                source_account_id: this.defaultSourceAccountId || '',
                target_account_id: '',
                amount: '',
                process_date: today(),
                remark: ''
            }
        }
    },
    methods: {
        resetForm() {
            this.formData = {
                id: null,
                source_account_id: this.defaultSourceAccountId || '',
                target_account_id: '',
                amount: '',
                process_date: today(),
                remark: ''
            };
            this.errors = {};
        },
        getFinanceTransfer() {
            this.$axios.get(this.selectedUrl)
                .then(response => {
                    this.formData = response.data;
                })
                .catch(error => {
                    this.$toastError(error.message);
                });
        },
        submitData() {
            // Client-side validation for amount
            if (parseFloat(this.formData.amount) <= 0) {
                this.$toastr.e(this.$t('amount_must_be_greater_than_zero'));
                return;
            }

            // Validate that source_account_id and target_account_id are different
            if (this.formData.source_account_id === this.formData.target_account_id) {
                this.$toastr.e(this.$t('source_and_target_account_must_be_different'));
                return;
            }

            this.loading = true;

            let url      = this.$refs.form.dataset['url'];
            let formData = formDataAssigner(new FormData, this.formData);
            formData.process_date = formData.process_date ? formatDateForServer(formData.process_date) : '';

            if (this.selectedUrl) {
                // for file update need to send by post.
                formData.append('_method', 'PATCH');
            }

            this.loading = true;

            this.submitFromFixin('post', url, formData);
        },
        afterSuccess({data}) {
            this.formData = {};
            $('#finance-transfer-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'finance-transfer-table');
            this.$hub.$emit('reload-finance-account-table');
        },
        afterSuccessFromGetEditData(response) {
            this.preloader = false;
            this.formData = response.data;
        },
    }
}
</script>
